import { Field, Select } from '@/ui/Field';
import type { Catalogo, Filtros } from './api';

/**
 * filtros.tsx — los cinco filtros que piden los informes.
 *
 * En el vanilla cada pantalla los pintaba por su cuenta y después los leía del
 * DOM por `id` (`rf-estado`, `rf-area`, `rf-survey`), con los mismos ids
 * repetidos en dos vistas del mismo archivo. Aquí el estado es el que manda y
 * el control solo lo enseña.
 */

const ESTADOS = [
  { valor: 'activos', texto: 'Activos' },
  { valor: 'inactivos', texto: 'Inactivos' },
  { valor: 'todos', texto: 'Todos' },
];

export function ControlesDeFiltro({
  catalogo, pide, filtros, onCambio,
}: {
  catalogo: Catalogo;
  /** Los que pide este informe: `mes`, `estado`, `area`, `survey`, `solicitud_tipo`. */
  pide: string[];
  filtros: Filtros;
  onCambio: (cambio: Partial<Filtros>) => void;
}) {
  return (
    <>
      {pide.includes('mes') && (
        <Field label="Mes" className="min-w-[10rem]">
          <Select value={filtros.mes} onChange={(e) => onCambio({ mes: e.target.value })}>
            {catalogo.meses.map((m) => (
              <option key={m.id} value={String(m.id)}>{m.name}</option>
            ))}
          </Select>
        </Field>
      )}

      {pide.includes('estado') && (
        <Field label="Estado" className="min-w-[9rem]">
          <Select value={filtros.estado} onChange={(e) => onCambio({ estado: e.target.value })}>
            {ESTADOS.map((e) => (
              <option key={e.valor} value={e.valor}>{e.texto}</option>
            ))}
          </Select>
        </Field>
      )}

      {pide.includes('area') && (
        <Field label="Área" className="min-w-[11rem]">
          <Select value={filtros.area_id} onChange={(e) => onCambio({ area_id: e.target.value })}>
            <option value="">Todas las áreas</option>
            {catalogo.areas.map((a) => (
              <option key={a.id} value={String(a.id)}>{a.name}</option>
            ))}
          </Select>
        </Field>
      )}

      {pide.includes('survey') && (
        <Field label="Encuesta" className="min-w-[14rem]">
          <Select value={filtros.survey_id} onChange={(e) => onCambio({ survey_id: e.target.value })}>
            <option value="">Selecciona una encuesta…</option>
            {catalogo.surveys.map((s) => (
              <option key={s.id} value={String(s.id)}>
                {s.title} {s.is_anonymous ? '(anónima)' : '(identificada)'}
              </option>
            ))}
          </Select>
        </Field>
      )}

      {pide.includes('solicitud_tipo') && (
        <Field label="Tipo de solicitud" className="min-w-[14rem]">
          <Select
            value={filtros.solicitud_type_id}
            onChange={(e) => onCambio({ solicitud_type_id: e.target.value })}
          >
            <option value="">Selecciona un tipo…</option>
            {catalogo.solicitud_tipos.map((t) => (
              <option key={t.id} value={String(t.id)}>{t.name}</option>
            ))}
          </Select>
        </Field>
      )}
    </>
  );
}

/** El mes de hoy, que es con el que abre el filtro de mes. Local, no UTC: en
 *  Bogotá, el 31 a las 19:00, `toISOString()` ya dice el mes siguiente. */
export function mesDeHoy(): string {
  return String(new Date().getMonth() + 1);
}
